<template>
    <div class="row">
        <div v-for="item in items" class="col-lg-2-4 col-md-3 col-sm-4 col-xs-12  no-padding">
            <cart-item :item="item"/>
        </div>
    </div>
</template>

<script>
    import CartItem from "./desktop/cart-item.vue";
    export default {
        name: "cart",
        components:{CartItem},
        computed: {},
        methods: {},
        data(){
            return {
                items:[{
                    img:"https://www.demon-tweeks.co.uk/oncirrus/3/image/product/zoom/0123456789/0123456789/tornado_.jpg",
                    data:[{
                        "label":"Группа",
                        "text":"Кузовгые"
                    },{
                        "label":"Тип",
                        "text":"Глушители"
                    },{
                        "label":"Производитель",
                        "text":"Bandoss"
                    },{
                        "label":"Цена",
                        "text":"1000 тенге"
                    }]
                },{
                    img:"https://www.breakerlink.com/blog/wp-content/uploads/2016/02/door.jpg",
                    data:[{
                        "label":"Группа",
                        "text":"Кузовгые"
                    },{
                        "label":"Тип",
                        "text":"Глушители"
                    },{
                        "label":"Производитель",
                        "text":"Bandoss"
                    },{
                        "label":"Цена",
                        "text":"1000 тенге"
                    }]
                }]
            }
    }
    }
</script>

<style scoped>

</style>